const DEV = process.env.NODE_ENV === 'development';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Rellax from 'rellax';



export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('init common');
		
		// if moveUpRellax is present
		
		
		if (document.querySelector('.moveUpRellax')) {
			const moveUp = new Rellax('.moveUpRellax', {
				// speed: 3,
				center: true,
				vertical: true,
				breakpoints: [500, 768, 1201],
			});
		}	

		if (document.querySelector('.moveUpCard')) {
			const moveUpCard = new Rellax('.moveUpCard', {
				speed: 2,
				center: true,
				vertical: true,
				breakpoints: [500, 768, 1201],
			});
		}
		
		if (document.querySelector('.moveUpRellaxCenter')) {
			const moveDownCenter = new Rellax('.moveDownRellaxCenter', {
				// speed: -3,
				center: true,
				round: true,
				vertical: true,
			});
		}

		if (document.querySelector('.moveDownRellax')) {
			const moveDown = new Rellax('.moveDownRellax', {
				speed: -2,
				center: false,
				round: true,
				vertical: true,
			});
		}
	

		const header = document.querySelector('header');
		const navMobile = document.querySelector('#navMobile');
		const hamburger = document.querySelector('#hamburgerMenu');
		const subMenu = document.querySelectorAll('.submenu');

		// const lineClamp = document.querySelectorAll('.line-clamp-6');

		// lineClamp.forEach((item) => {
		// 	item.addEventListener('click', () => {
		// 		console.log('click');
		// 		item.classList.toggle('line-clamp-6');

		// 	});
		// });

		// const lineClampMobile = document.querySelectorAll('.line-clamp-8');

		// lineClampMobile.forEach((item) => {
		// 	item.addEventListener('click', () => {
		// 		console.log('click 8');
		// 		item.classList.toggle('line-clamp-8');
		// 	});
		// });
		

		

		const scrollerFooter = document.querySelector('.scrollerFooter');

		hamburger.addEventListener('click', () => {
			navMobile.classList.toggle('closeNav');
			navMobile.classList.toggle('openNav');
		});

		subMenu.forEach((item) => {
			item.addEventListener('click', () => {

				// close all other submenus
				subMenu.forEach((el) => {
					if (el !== item) {
						el.querySelector('ul').classList.remove('openSubMenu');
						el.querySelector('span img').classList.remove('rotate-180');
					}
				});

				item.querySelector('span img').classList.toggle('rotate-180');
				const ul = item.querySelector('ul'); // Trova il <ul> annidato all'interno di item
				if (ul) {
					ul.classList.toggle('openSubMenu'); // Aggiunge o rimuove la classe
				}
			});
		});


		//scroller footer
		scrollerFooter.addEventListener('click', () => {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});

		// verifica privacy solo per il form newsletter
		jQuery(document).ready(function($) {
		const $form = $('form.newsletter-footer-form');

			if ($form.length) {
				$form.find('input[type="submit"]').on('click', function(e) {
					const scelta = $form.find('input[name="acceptance-privacy"]:checked');

					if (scelta.length === 0 || scelta.val() !== 'Si') {
						e.preventDefault();
						alert("Per inviare il form è necessario accettare la Privacy Policy selezionando 'Sì'.");
					}
				});
			}
		});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		console.log('finalize common');
	},
};
